import App from '../../client/shared/pages/app'
import HomePage from '../../client/shared/pages/home/homePage'
import LandingPage from '../../client/shared/pages/landing/landingPage'
import NotFoundPage from '../../client/shared/pages/notFoundPage'
import SearchPage from '../../client/v1/pages/search'

import createAppContainer from '../../client/shared/containers/appContainer'
import createHomePageContainer from '../../client/shared/containers/homePageContainer'
import createLandingPageContainer from '../../client/shared/containers/landingPageContainer'
import createNotFoundContainer from '../../client/shared/containers/notFoundContainer'
import createSearchPageContainer from '../../client/shared/containers/searchPageContainer'

import { RouteConfig } from 'react-router-config'

const routeConfig: RouteConfig[] = [
  {
    path: '/',
    component: createAppContainer(App),
    routes: [
      {
        path: '/',
        exact: true,
        component: createHomePageContainer(HomePage)
      },
      {
        component: createSearchPageContainer(SearchPage),
        path: '/category/*'
      },
      {
        component: createSearchPageContainer(SearchPage),
        path: '/tags/:tags'
      },
      {
        component: createSearchPageContainer(SearchPage),
        path: '/attributes/:key/:value'
      },
      {
        component: createSearchPageContainer(SearchPage),
        path: '/search'
      },
      {
        path: '/free/:page',
        component: createLandingPageContainer(LandingPage)
      },
      {
        path: '/*',
        component: createNotFoundContainer(NotFoundPage)
      }
    ]
  }
]

export default routeConfig
